__turbopack_context__.v({
  "container": "Zd30xa_container",
  "dot": "Zd30xa_dot",
  "selected": "Zd30xa_selected",
  "size_lg": "Zd30xa_size_lg",
  "size_md": "Zd30xa_size_md",
  "size_sm": "Zd30xa_size_sm",
  "size_xs": "Zd30xa_size_xs",
});
